/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Prepaid_PendingInputs */



/**
* | output |
* | --- |
* | "Added on the start date" |
*
* @param {Partner_Org_Contract_Prepaid_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_prepaid_pending = /** @type {((inputs?: Partner_Org_Contract_Prepaid_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Prepaid_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird zum Startdatum gutgeschrieben")
	return /** @type {LocalizedString} */ ("Added on the start date")
});